import React from 'react';
import { motion } from 'framer-motion';
import styles from './CommerceOffer.module.scss';

interface CommerceOfferProps {
  onAction: (action: string) => void;
}

const CommerceOffer: React.FC<CommerceOfferProps> = ({ onAction }) => {
  return (
    <motion.div
      className={styles.wrap}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
    >
      <p className={styles.lead}>
        Si registrás tu comercio podés cargar tu listado de precios para que nuestra IA lo categorice y lo sume a la base.
        Cuando alguien solicite un material que coincida con tu oferta, te avisamos en la app y por mail.
      </p>
      <div className={styles.actions}>
        <button type="button" className={styles.primary} onClick={() => onAction('commerceOnboardingContinue')}>
          Registrar mi comercio
        </button>
        <button type="button" className={styles.secondary} onClick={() => onAction('commerceOnboardingSkip')}>
          Ahora no
        </button>
      </div>
    </motion.div>
  );
};

export default CommerceOffer;
